import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { useStyles } from 'features/command-center/components/shared';

import { TEAM_COLUMN_NAME } from '../../productionBoard.constants';

export const RecruiterExpandableRow = ({ columns, row }) => {
  const classes = useStyles();

  return (
    <TableRow hover>
      <TableCell />

      {columns.map(col => {
        if (col.options.display !== true) return null;

        const isNameColumn = col.name === TEAM_COLUMN_NAME;

        return (
          <TableCell key={col.name} align={isNameColumn ? 'left' : 'right'}>
            <span className={classes.regularWeightRow}>
              {col?.options?.customBodyRender
                ? col.options.customBodyRender(row[col.name])
                : row[col.name]}
            </span>
          </TableCell>
        );
      })}
    </TableRow>
  );
};
